module.exports = __webpack_public_path__ + "static/img/EE@3x.65bd0016.jpg";